import { Route } from "@angular/router";
import { PorteurDetailsComponent } from "./porteur-details.component";
import { DotationRouting } from "./dotation/dotation-routing";
import { MutationRouting } from "./mutation/mutation-routing";
import { PorteurResolver } from "../shared/porteur-resolver";
import { MarquageRouting } from "./marquage/marquage.routing";

export const PorteurDetailsRouting: Route = {
  path: ":numPorteur",
  component: PorteurDetailsComponent,
  resolve: {
    porteur: PorteurResolver
  },
  children: [
    { path: '', redirectTo: 'dotation', pathMatch: 'full' },
    DotationRouting,
    MutationRouting,
    MarquageRouting
  ],
  data: {
    breadcrumb: ":porteur.porteur"
  }
};
